import { useState } from 'react';

import { useInstanceCallback } from '@/scenarios/legacy-player/hooks/useInstanceCallback';
import { useOnCurrentTimeChanged } from '@/scenarios/legacy-player/hooks/useOnCurrentTimeChanged';
import { useOnDVRDurationChanged } from '@/scenarios/legacy-player/hooks/useOnDvrDurationChanged';
import { useOnDVRTimeChanged } from '@/scenarios/legacy-player/hooks/useOnDvrTimeChanged';

const ON_AIR_TIME_RANGE = 10;
const REFRESH_INTERVAL = 1000;

export const useIsOnAir = (): boolean => {
    const [isOnAir, setIsOnAir] = useState<boolean>(true);

    const calculateIsOnAir = useInstanceCallback((instance) => {
        if (!instance) {
            return;
        }

        const { currentTime, dvrDuration, dvrStartTime } = instance;

        if (dvrStartTime !== undefined && dvrDuration !== undefined && currentTime !== undefined) {
            const airStartTime = dvrStartTime + dvrDuration - ON_AIR_TIME_RANGE;
            setIsOnAir(dvrDuration === Infinity || currentTime > airStartTime);
        }
    });

    useOnCurrentTimeChanged(calculateIsOnAir, REFRESH_INTERVAL);
    useOnDVRTimeChanged(calculateIsOnAir);
    useOnDVRDurationChanged(calculateIsOnAir);

    return isOnAir;
};
